import { IkasProductOptionSet, IkasProductOptionSetTranslations } from ".";
import { IkasProductOption, IkasProductOptionType } from "./option";
import { initIkasProductOption } from "./option/init";

export function initIkasProductOptionSet(
  optionSet: IkasProductOptionSet,
  locale: string | null
) {
  optionSet.options.forEach((option) => {
    option.productOptionSetId = optionSet.id;
    initIkasProductOption(option);
  });

  if (optionSet.translations && locale) {
    setTranslations(optionSet, optionSet.translations, locale);
    delete optionSet.translations;
  }
  setChildOptions(optionSet);
  initOptionValues(optionSet);
}

function setTranslations(
  optionSet: IkasProductOptionSet,
  translations: IkasProductOptionSetTranslations[],
  locale: string
) {
  if (translations && translations.some((t) => t.locale === locale)) {
    const localeTranslations = translations.find((t) => t.locale === locale);

    localeTranslations?.options?.forEach((translatedOption) => {
      const option = optionSet.options.find(
        (o) => o.id === translatedOption.id
      );

      if (option) {
        option.name = translatedOption.name || option.name;
        option.optionalText =
          translatedOption.optionalText || option.optionalText;

        if (option.type === IkasProductOptionType.CHOICE) {
          translatedOption.values?.forEach((translatedValue) => {
            const selectValue = option.selectSettings?.values.find(
              (sv) => sv.id === translatedValue.id
            );
            if (selectValue) {
              selectValue.value = translatedValue.value || selectValue.value;
            }
          });
        }
      }
    });
  }
}

export function setChildOptions(optionSet: IkasProductOptionSet) {
  optionSet.options.forEach((option) => {
    const childOptions = optionSet.options.filter(
      (o) => o.requiredOptionId === option.id
    );
    if (childOptions.length) {
      option.childOptions = childOptions;
    }
  });
}

export function initOptionValues(optionSet: IkasProductOptionSet) {
  optionSet.options.forEach((o) => initValues(o));
}

export function initValues(option: IkasProductOption) {
  if (!option.isOptional) {
    option.values = [];
    if (option.childOptions) {
      option.childOptions.forEach((co) => initValues(co));
    }
  }
}
